module.exports = __webpack_public_path__ + "static/media/hubpic7.d5bc7e9c.jpg";